import { render, staticRenderFns } from "./StickyBarBlock.vue?vue&type=template&id=5c16dc04&scoped=true&"
import script from "./StickyBarBlock.vue?vue&type=script&lang=js&"
export * from "./StickyBarBlock.vue?vue&type=script&lang=js&"
import style0 from "./StickyBarBlock.vue?vue&type=style&index=0&id=5c16dc04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c16dc04",
  null
  
)

export default component.exports